@if (status()) {
    <span class="inline-flex items-center gap-1">
        <sh-tag
            data-testid="details-header-container-status"
            [attr.data-status]="status()"
            [attr.data-on-hold]="isOnHold()"
            [color]="statusColorMap[status()]"
            [label]="'common.status.' + (isInternal() ? 'internal.' : 'external.') + status() | translate"
            [condensed]="size() === 'sm'"
            active
        ></sh-tag>
        @if (isOnHold()) {
            <sh-icon data-testid="details-header-icon-on-hold" icon="pause-circle" size="s"></sh-icon>
        }
    </span>
}
